import { render, staticRenderFns } from "./AdditionalItemsMenu.vue?vue&type=template&id=3b5a72c2&scoped=true&"
import script from "./AdditionalItemsMenu.vue?vue&type=script&lang=ts&"
export * from "./AdditionalItemsMenu.vue?vue&type=script&lang=ts&"
import style0 from "./AdditionalItemsMenu.vue?vue&type=style&index=0&id=3b5a72c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5a72c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';
installComponents(component, {VBtn,VIcon,VMenu,VVirtualScroll})
